<div class="search-tiles-wrapper">
    <div>
        <mat-form-field style="width: 100% !important;">
            <mat-label>Search (Device Num, Sim Num or Sim Cell)</mat-label>
            <input matInput [(ngModel)]="searchText" (keydown)="keyDownEnter($event);" [disabled]="simLocations == null">
            <!-- Search button -->
            <button matSuffix mat-icon-button *ngIf="searchText.length > 0" aria-label="Search" (click)="getMapData()">
                <mat-icon>search</mat-icon>
            </button>
            <!-- Clear button -->
            <button matSuffix mat-icon-button *ngIf="searchText.length > 0" aria-label="Clear" (click)="searchText=''; getMapData()">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
    </div>
    @if (simLocations != null) {
        <div class="info-cards">
            <mat-card>
                <h4>Distinct Devices</h4>
                <div>{{distinctDeviceCount}}</div>
            </mat-card>
            <mat-card>
                <h4>Invalid Tower Locations</h4>
                <div>{{invalidLocationCount}}</div>
            </mat-card>
            <mat-card>
                <h4>Unknown Sim Locations</h4>
                <div>{{unknownLocationCount}}</div>
            </mat-card>
        </div>
    } @else {
        <div class="info-cards">
            <mat-card class="skeleton-cards">
                <ngx-skeleton-loader class="skeleton-loader" count="2" appearance="line" />
            </mat-card>
            <mat-card class="skeleton-cards">
                <ngx-skeleton-loader class="skeleton-loader" count="2" appearance="line" />
            </mat-card>
            <mat-card class="skeleton-cards">
                <ngx-skeleton-loader class="skeleton-loader" count="2" appearance="line" />
            </mat-card>
        </div>
    }
</div>
<div class="map-container">
    <huge-monorepo-base-map
        [locations]="simLocations"
        [calculateCenter]="shouldCalculateCenter"
        [clusterMarkers]="shouldClusterMarkers"
        [showTowerLegend]="false"
        [updateActionButtons]="true"
    >
    </huge-monorepo-base-map>
</div>
<!-- @if (simLocations && simLocations.length == 0) {
    <div>
        No locations to display
    </div>
} @else {
    <mat-spinner [diameter]="40" class="mauto"></mat-spinner>            
} -->
